import { store } from '../../packages/neb-redux/neb-redux-store';

export const popupOpened = () => {
  const { popup } = store.getState();
  return popup.overlays?.length > 0 || popup.main?.length > 0;
};
